import React from "react";
import PropTypes from "prop-types";
import CompanyEdit from "./company_edit";

function CompanyPage(props) {
  const { name, logo_image, website_url, concept_pitch, defaultCompanyImage } = props;
  const CompanyImage = logo_image ? logo_image : defaultCompanyImage;

  return (
    <div id='object_cover' className='container-fluid'>
      <div className='row d-flex justify-content-center'>
        <div className='container'>
          <div className='row d-flex justify-content-center no-gutter'>
            <div id='object_unit' className='col-12 col-sm-10'>
              <table className='table'>
                <tbody>
                  <tr>
                    <td id='company_image' className='text-center'>
                      <img src={CompanyImage} className='img-thumbnail' alt={name} />
                    </td>
                    <td id='object-info' className='d-none d-md-table-cell'>
                      <h2 id='object-name'>{name}</h2>
                      { website_url && (
                        <div id='object-link'>
                          <a href={website_url} target='_blank' rel='noopener noreferrer' className='company-url'>{website_url}</a>
                        </div>
                      )}
                      { concept_pitch && <p>{concept_pitch}</p> }
                    </td>
                    <CompanyEdit {...props} isMobile={false} />
                  </tr>
                  <tr className='d-md-none text-center'>
                    <td id='object-info'>
                      <h2 id='object-name'>{name}</h2>
                      { website_url && <a href={website_url} target='_blank' rel='noopener noreferrer'>{website_url}</a> }
                      { concept_pitch && <p>{concept_pitch}</p> }
                      <p><CompanyEdit {...props} isMobile /></p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

CompanyPage.propTypes = {
  name: PropTypes.string.isRequired,
  logo_image: PropTypes.string,
  website_url: PropTypes.string,
  concept_pitch: PropTypes.string,
  defaultCompanyImage: PropTypes.string.isRequired
};

CompanyPage.defaultProps = {
  logo_image: "",
  website_url: "",
  concept_pitch: ""
};

export default CompanyPage;
